module.exports = __webpack_public_path__ + "img/LIVEPEN BOX 2-m.f9adcbb1.png";